//#region src/index.ts
function sleep(ms) {
	return new Promise((resolve) => {
		setTimeout(resolve, ms);
	});
}
async function retryWithBackoff(operation, options = {}) {
	const maxAttempts = normalizePositiveInteger(options.maxAttempts, 3);
	const initialDelayMs = normalizeNonNegativeInteger(options.initialDelayMs, 100);
	const backoffFactor = normalizePositiveNumber(options.backoffFactor, 2);
	let delayMs = initialDelayMs;
	for (let attempt = 1; attempt <= maxAttempts; attempt += 1) try {
		return await operation();
	} catch (error) {
		if (attempt >= maxAttempts || options.shouldRetry?.(error, attempt) === false) throw error;
		await sleep(delayMs);
		delayMs = Math.trunc(delayMs * backoffFactor);
	}
	throw new Error("retryWithBackoff exhausted without returning or throwing");
}
function toErrorMessage(error) {
	if (error instanceof Error) return error.message;
	return String(error);
}
function normalizePositiveInteger(value, fallback) {
	if (typeof value !== "number" || !Number.isFinite(value)) return fallback;
	return Math.max(1, Math.trunc(value));
}
function normalizeNonNegativeInteger(value, fallback) {
	if (typeof value !== "number" || !Number.isFinite(value)) return fallback;
	return Math.max(0, Math.trunc(value));
}
function normalizePositiveNumber(value, fallback) {
	if (typeof value !== "number" || !Number.isFinite(value) || value <= 0) return fallback;
	return value;
}

//#endregion
export { retryWithBackoff, sleep, toErrorMessage };
//# sourceMappingURL=index.js.map